import { render, staticRenderFns } from "./ShowAnkles.vue?vue&type=template&id=4f1597ad&scoped=true&"
import script from "./ShowAnkles.vue?vue&type=script&lang=js&"
export * from "./ShowAnkles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f1597ad",
  null
  
)

export default component.exports